import { useStore } from '@nanostores/react'
import user from 'assets/image/icons/svg/user.svg'
import { $messages } from 'features/messaging/model/stores.ts'
import { memo } from 'react'
import { appDay } from 'shared/day'

import type { Message as DataMessage } from '../../model/types.ts'

import { formatTime, type MessageWithFlag } from '../../utils/utils'
import { Reactions } from '../Emoji/Reactions'
import { MessageBody } from './Body'
import css from './Message.module.css'

function Message_({ id, showAvatar = false }: MessageWithFlag) {
	const message = useGetById(id)

	if (!message) {
		return null
	}

	const isSystemMessage = message.render_format === 'SYSTEM'
	const isDeleted = message.render_format === 'RECALLED'

	return (
		<section className={css.root}>
			{!isSystemMessage && showAvatar && (
				<img
					alt='avatar'
					className={css.avatar}
					src={message.from?.pictureUrl || user}
				/>
			)}

			{showAvatar && <Sender {...message} />}

			{isDeleted ? (
				<p className={css.deleted}>This message has been deleted.</p>
			) : (
				<div className={css.textBlock}>
					<MessageBody {...message} />
				</div>
			)}

			<Reactions className={css.reactFooter} {...message} />
		</section>
	)
}

function Sender({
	created_at: createdAt,
	from
}: Pick<DataMessage, 'created_at' | 'from'>) {
	const created = appDay(createdAt)
	return (
		<p className={css.sender}>
			<a
				className={css.name}
				href={`https://www.linkedin.com/in/${from?.entityId}/`}
				rel='noreferrer'
				target='_blank'
			>
				{from?.fullName}
			</a>

			<time
				className={css.time}
				dateTime={createdAt}
				title={created.format('dddd, MMMM D, YYYY')}
			>
				{formatTime(createdAt)}
			</time>
		</p>
	)
}

function useGetById(id: string): DataMessage | undefined {
	const map = useStore($messages, {
		keys: [id]
	})

	return map[id]
}

export const Message = memo(Message_)
